<form [formGroup]="productForm" (submit)="onSubmit()">
  <mat-card>
    <div fxLayout="row" fxLayoutAlign="center start">
      <a routerLink="/administrador/productos" mat-icon-button class="back">
        <mat-icon>arrow_back</mat-icon>
      </a>
      <div fxFlex>
        <mat-card-title>Edición de producto</mat-card-title>
      </div>
    </div>
    <mat-card-content>
      <div fxLayout="row wrap" fxLayout.xs="column" class="main-form" fxLayoutAlign.gt-xs="center center">
        <mat-form-field fxFlex="50">
          <input matInput placeholder="Descripción" formControlName="productDescription">
        </mat-form-field>
        <mat-form-field fxFlex="50">
          <mat-select placeholder="Estado" formControlName="status">
            <mat-option value="A">Activo</mat-option>
            <mat-option value="D">Desactivado</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field fxFlex="50">
          <input matInput type="number" placeholder="Orden de impresión" formControlName="sort">
        </mat-form-field>
        <mat-form-field fxFlex="50">
          <input matInput placeholder="Imagen de header" formControlName="headerImage">
        </mat-form-field>
        <mat-form-field fxFlex="50">
          <input matInput placeholder="Referencia Legal" formControlName="legalReference">
        </mat-form-field>
        <mat-slide-toggle fxFlex="50" formControlName="isPrintable">¿Se imprime en el periódico?</mat-slide-toggle>
      </div>
      <div formArrayName="fields">
        <h2>Campos:</h2>
        <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign.gt-sm="start center" class="fields"
          *ngFor="let field of fields.controls; let i=index" [formGroupName]="i">
          <!-- <h2 fxFlex="100">Campo # {{i}}</h2> -->
          <mat-form-field fxFlex>
            <input matInput placeholder="Nombre" formControlName="name">
          </mat-form-field>
          <mat-form-field fxFlex>
            <mat-select placeholder="Tipo" formControlName="type">
              <mat-option value="editor">Editor HTML</mat-option>
              <mat-option value="textarea">Textarea</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field fxFlex>
            <input matInput type="number" placeholder="Orden de impresión" formControlName="sortId">
          </mat-form-field>
          <div>
            <mat-checkbox formControlName="printTitle">Imprimir título</mat-checkbox>
            <button type="button" mat-icon-button mat-tooltip="Eliminar" (click)="spliceField(i)">
              <mat-icon aria-label="Eliminar" color="warn">delete</mat-icon>
            </button>
          </div>
        </div>
        <div class="add-button-bar" fxLayout="row">
          <div fxFlex></div>
          <button type="button" mat-icon-button mat-tooltip="Agregar Campo" (click)="addField()">
            <mat-icon aria-label="Agregar Campo">add</mat-icon>
          </button>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions align="end">
      <button type="submit" mat-raised-button color="primary">
        <mat-icon>save</mat-icon> Guardar
      </button>
      <button type="button" mat-raised-button (click)="revert()">
        <mat-icon>cancel</mat-icon> Reiniciar
      </button>
    </mat-card-actions>
  </mat-card>
</form>
